export default "__VITE_ASSET__DMFre5_r__"